import React from "react";
import { AxiosResponse } from "axios";
import AuthTokenHolder from "./AuthTokenHolder";
import { showErrorModal, showLoginExpiryModal } from "./utils";

/**
 * 授权过期
 */
function authInvalidResponseHandler(error) {
  AuthTokenHolder.clearToken();

  showLoginExpiryModal();

  return Promise.reject(error);
}

/**
 * 最后默认兜底的错误处理方式
 */
function defaultResponseHandler(error) {
  const errorMessage = error?.message || "请检查您的网络设置，请求发送失败！";

  const requestUrl = error?.config?.url;

  showErrorModal(
    "网络请求错误",
    <div>
      {errorMessage}
      <div>path:{requestUrl}</div>
    </div>
  );

  return Promise.reject(error);
}

/**
 * 未拿到数据的情况，先从响应的状态码判断，最后走兜底
 */
export default function responseRejectedHandler(error) {
  const response = error?.response as AxiosResponse;

  const statusCode = response?.status;

  switch (statusCode) {
    // 权限校验失败状态
    case 401:
    case 403:
      return authInvalidResponseHandler(error);

    // 权限校验失败状态
    default:
      return defaultResponseHandler(error);
  }
}
